import { OrderLoading } from './order-loading'

export default OrderLoading
